/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GUF
 */
export interface GUF {
  /**
   *
   * @type {string}
   * @memberof GUF
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof GUF
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GUF
   */
  readonly updated?: Date;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof GUF
   */
  internalId: string | null;
  /**
   *
   * @type {string}
   * @memberof GUF
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GUF
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {GUFQualityRegimeEnum}
   * @memberof GUF
   */
  qualityRegime: GUFQualityRegimeEnum | null;
  /**
   *
   * @type {GUFDeliveryContextEnum}
   * @memberof GUF
   */
  deliveryContext: GUFDeliveryContextEnum | null;
  /**
   * Format: YYYY-MM-DD, YYYY-MM, or YYYY
   * @type {Date}
   * @memberof GUF
   */
  startTime: Date | null;
  /**
   * Format: YYYY-MM-DD, YYYY-MM, or YYYY
   * @type {Date}
   * @memberof GUF
   */
  endTime: Date | null;
  /**
   *
   * @type {string}
   * @memberof GUF
   */
  identificationLicence: string | null;
  /**
   *
   * @type {GUFLegalTypeEnum}
   * @memberof GUF
   */
  legalType: GUFLegalTypeEnum | null;
  /**
   *
   * @type {GUFPrimaryUsageTypeEnum}
   * @memberof GUF
   */
  primaryUsageType: GUFPrimaryUsageTypeEnum | null;
  /**
   *
   * @type {object}
   * @memberof GUF
   */
  secondaryUsageTypes: object;
  /**
   *
   * @type {GUFHumanConsumptionEnum}
   * @memberof GUF
   */
  humanConsumption: GUFHumanConsumptionEnum | null;
  /**
   *
   * @type {object}
   * @memberof GUF
   */
  licensedQuantities: object;
  /**
   *
   * @type {string}
   * @memberof GUF
   */
  dataOwner: string;
}

/**
 * @export
 */
export const GUFQualityRegimeEnum = {
  Imbro: "IMBRO",
  ImbroA: "IMBRO/A",
} as const;
export type GUFQualityRegimeEnum = (typeof GUFQualityRegimeEnum)[keyof typeof GUFQualityRegimeEnum];

/**
 * @export
 */
export const GUFDeliveryContextEnum = {
  Waterwet: "waterwet",
  Omgevingswet: "omgevingswet",
} as const;
export type GUFDeliveryContextEnum =
  (typeof GUFDeliveryContextEnum)[keyof typeof GUFDeliveryContextEnum];

/**
 * @export
 */
export const GUFLegalTypeEnum = {
  Melding: "melding",
  Beschikking: "beschikking",
} as const;
export type GUFLegalTypeEnum = (typeof GUFLegalTypeEnum)[keyof typeof GUFLegalTypeEnum];

/**
 * @export
 */
export const GUFPrimaryUsageTypeEnum = {
  AgrarischeDoeleinden: "agrarischeDoeleinden",
  Bemaling: "bemaling",
  Brandblusvoorziening: "brandblusvoorziening",
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  Grondwatersanering: "grondwatersanering",
  IndustrieleToepassing: "industrieleToepassing",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
  OpenbareDrinkwatervoorziening: "openbareDrinkwatervoorziening",
  OverigeDoeleinden: "overigeDoeleinden",
} as const;
export type GUFPrimaryUsageTypeEnum =
  (typeof GUFPrimaryUsageTypeEnum)[keyof typeof GUFPrimaryUsageTypeEnum];

/**
 * @export
 */
export const GUFHumanConsumptionEnum = {
  Ja: "ja",
  Nee: "nee",
  Onbekend: "onbekend",
} as const;
export type GUFHumanConsumptionEnum =
  (typeof GUFHumanConsumptionEnum)[keyof typeof GUFHumanConsumptionEnum];

/**
 * Check if a given object implements the GUF interface.
 */
export function instanceOfGUF(value: object): value is GUF {
  if (
    (!("internalId" in (value as Record<string, any>)) &&
      !("internal_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["internalId"] === undefined &&
      (value as Record<string, any>)["internal_id"] === undefined)
  )
    return false;
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (
    (!("deliveryContext" in (value as Record<string, any>)) &&
      !("delivery_context" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryContext"] === undefined &&
      (value as Record<string, any>)["delivery_context"] === undefined)
  )
    return false;
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (
    (!("endTime" in (value as Record<string, any>)) &&
      !("end_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endTime"] === undefined &&
      (value as Record<string, any>)["end_time"] === undefined)
  )
    return false;
  if (
    (!("identificationLicence" in (value as Record<string, any>)) &&
      !("identification_licence" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identificationLicence"] === undefined &&
      (value as Record<string, any>)["identification_licence"] === undefined)
  )
    return false;
  if (
    (!("legalType" in (value as Record<string, any>)) &&
      !("legal_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["legalType"] === undefined &&
      (value as Record<string, any>)["legal_type"] === undefined)
  )
    return false;
  if (
    (!("primaryUsageType" in (value as Record<string, any>)) &&
      !("primary_usage_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["primaryUsageType"] === undefined &&
      (value as Record<string, any>)["primary_usage_type"] === undefined)
  )
    return false;
  if (
    (!("secondaryUsageTypes" in (value as Record<string, any>)) &&
      !("secondary_usage_types" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["secondaryUsageTypes"] === undefined &&
      (value as Record<string, any>)["secondary_usage_types"] === undefined)
  )
    return false;
  if (
    (!("humanConsumption" in (value as Record<string, any>)) &&
      !("human_consumption" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["humanConsumption"] === undefined &&
      (value as Record<string, any>)["human_consumption"] === undefined)
  )
    return false;
  if (
    (!("licensedQuantities" in (value as Record<string, any>)) &&
      !("licensed_quantities" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["licensedQuantities"] === undefined &&
      (value as Record<string, any>)["licensed_quantities"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GUFFromJSON(json: any): GUF {
  return GUFFromJSONTyped(json, false);
}

export function GUFFromJSONTyped(json: any, ignoreDiscriminator: boolean): GUF {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    internalId: json["internal_id"],
    broId: json["bro_id"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    deliveryContext: json["delivery_context"],
    startTime: json["start_time"] == null ? null : new Date(json["start_time"]),
    endTime: json["end_time"] == null ? null : new Date(json["end_time"]),
    identificationLicence: json["identification_licence"],
    legalType: json["legal_type"],
    primaryUsageType: json["primary_usage_type"],
    secondaryUsageTypes: json["secondary_usage_types"],
    humanConsumption: json["human_consumption"],
    licensedQuantities: json["licensed_quantities"],
    dataOwner: json["data_owner"],
  };
}

export function GUFToJSON(json: any): GUF {
  return GUFToJSONTyped(json, false);
}

export function GUFToJSONTyped(
  value?: Omit<GUF, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    delivery_context: value["deliveryContext"],
    start_time:
      value["startTime"] == null
        ? value["startTime"]
        : value["startTime"].toISOString().substring(0, 10),
    end_time:
      value["endTime"] == null ? value["endTime"] : value["endTime"].toISOString().substring(0, 10),
    identification_licence: value["identificationLicence"],
    legal_type: value["legalType"],
    primary_usage_type: value["primaryUsageType"],
    secondary_usage_types: value["secondaryUsageTypes"],
    human_consumption: value["humanConsumption"],
    licensed_quantities: value["licensedQuantities"],
    data_owner: value["dataOwner"],
  };
}
